export const STANDARD_INVENTORY_CONFIRMATION_HOURS = '48';
export const DELAYED_INVENTORY_CONFIRMATION_HOURS = '72';

export type InventoryConfirmationHours =
  | typeof STANDARD_INVENTORY_CONFIRMATION_HOURS
  | typeof DELAYED_INVENTORY_CONFIRMATION_HOURS;

export const INVENTORY_CONFIRMATION_HOURS_OPTIONS: InventoryConfirmationHours[] = [
  STANDARD_INVENTORY_CONFIRMATION_HOURS,
  DELAYED_INVENTORY_CONFIRMATION_HOURS,
];

export const getInventoryConfirmationHours = (delayedInventoryConfirmationEnabled: boolean): InventoryConfirmationHours =>
  delayedInventoryConfirmationEnabled ? DELAYED_INVENTORY_CONFIRMATION_HOURS : STANDARD_INVENTORY_CONFIRMATION_HOURS;

export const formatInventoryConfirmationTiming = (hours: InventoryConfirmationHours): string => `${hours} hours after start`;
